jQuery(function () {
    var stepAreaOnPage = $('.step-area').length > 0;
    if (stepAreaOnPage) {
        var checkboxes = $('.step-checkbox > input');
        checkboxes.change(function (e) {
            // Checkbox is checked
            var checked = $(e.target).is(':checked');
            var checkboxId = $(e.target).prop('id');
            var parentId = parseInt(getUrlSearchParam('id').toString(), 10);
            var parentType = $(e.target).data('parent-type');
            // Send Ajax with checkbox change
            updateStepInChecklist(checked, checkboxId, parentId, parentType);
        });
    }
    function updateStepInChecklist(checked, checkboxId, parentId, parentType) {
        $.ajax({
            url: '/steg/uppdatera-steg',
            method: 'POST',
            data: {
                check: checked,
                checkboxId: checkboxId,
                parentId: parentId,
                parentType: parentType
            },
        }).done(function (response) {
            updateIsStarted(parentId, parentType);
        }).fail(function (response) {
            // TODO: What to do when fail?
        });
    }
    function updateIsStarted(parentId, parentType) {
        $.ajax({
            url: '/steg/vaxla-status',
            method: 'GET',
            data: {
                parentId: parentId,
                parentType: parentType
            }
        }).done(function (response) {
            var toggleActiveButton = $('#toggle-active-button');
            toggleActiveButton.toggleClass('button--orange');
            toggleActiveButton.children().toggleClass('hidden');
            var toogleBarText = $('#action-active-status');
            toogleBarText.toggleClass('hidden');
        }).fail(function (response) {
            // TODO: What to do when fail?
        });
    }
    function getUrlSearchParam(name) {
        var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.search);
        return (results !== null) ? results[1] || 0 : false;
    }
});
